export const CHECKBOX_INPUT_UNIQUE_ID_PREFIX = "fs-checkbox";
export const CHECKBOX_GROUP_UNIQUE_ID_PREFIX = "fs-checkbox-group";
